import React, { useEffect, useRef } from 'react';

/**
 * Puce « Ouvert · Ferme à 19h30 » / « Fermé. Ouvrira demain à 09h30 ».
 *
 * Piège n°2 du plan : la maquette employait deux conventions inverses — sur le
 * listing `.salon-row-status` par défaut fermé + modificateur `.open`, sur le
 * détail `.salon-status` par défaut ouvert + modificateur `.closed`. Les deux
 * classes de base restent (le CSS diffère : le détail a une pastille `●`), mais
 * le modificateur est désormais toujours porté par le même booléen.
 *
 * La classe est réaffirmée après le montage (`useEffect` + `ref`) : React 17
 * repatche le texte des nœuds qui divergent à l'hydratation, mais **pas** les
 * attributs. Le fuseau commun de `services/openingStatus.js` supprime l'écart
 * systématique entre le rendu serveur et le rendu navigateur ; reste la fenêtre
 * de quelques centaines de millisecondes où les deux passes tombent de part et
 * d'autre d'une heure d'ouverture, qui laisserait sinon « Ouvert » en rouge.
 */
const StatusPill = ({ isOpen, label, variant = 'row', title }) => {
  const pillRef = useRef(null);
  const className = [
    variant === 'panel' ? 'salon-status' : 'salon-row-status',
    variant === 'panel' ? (isOpen ? null : 'closed') : isOpen ? 'open' : null,
  ]
    .filter(Boolean)
    .join(' ');

  useEffect(() => {
    if (pillRef.current) pillRef.current.className = className;
  }, [className]);

  if (!label) return null;

  // `title` porte le motif d'une dérogation (jour exceptionnel, fermeture
  // forcée) : la puce n'a pas la place de l'afficher en clair.
  return (
    <span ref={pillRef} className={className} title={title || undefined}>
      {label}
    </span>
  );
};

export default StatusPill;
